import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=76bfe25c&"
import script from "./Datatable.vue?vue&type=script&lang=ts&"
export * from "./Datatable.vue?vue&type=script&lang=ts&"
import style0 from "./Datatable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports